class CollectionTitle extends HTMLElement {
  static classes = {
    fixed: 'fixed',
    static: 'static',
  };
  static ISFIXED = 1;
  static ISSTATIC = 0;
  status; initialScrollTop;

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.initialScrollTop = this.offsetTop;
    this.checkPosition();
    window.onscroll = () => {
      this.checkPosition();
    };
  }

  checkPosition = () => {
    const y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if (y >= this.initialScrollTop) {
      this.setFixed();
    }
    else {
      this.setStatic();
    }
  }

  setFixed = () => {
    this.classList.add(CollectionTitle.classes.fixed);
    this.status = CollectionTitle.ISFIXED;
  }

  setStatic = () => {
    this.classList.remove(CollectionTitle.classes.fixed);
    this.status = CollectionTitle.ISSTATIC;
  }
}
if (!window.customElements.get("collection-title")) {
  window.customElements.define("collection-title", CollectionTitle);
}

class CollectionList extends HTMLElement {
  view3Classes; page;
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    const params = new URLSearchParams(window.location.search);
    this.page = params.get('page') || 1;
    this.view3Classes = this.dataset.view3.split(' ');
    window.addEventListener(Utils.E_PRODUCT_VIEW, (e) => {
      const card = e.detail;
      if(card.dataset.page != this.page) {
        this.page = card.dataset.page;
        params.set('page', this.page);
        
        window.history.replaceState(null, null, window.location.pathname + '?' + params.toString());
      }
    });
    this.scroll2prod();
  }

  view = (n) => {
    switch(n) {
      case 2:
        this.view2();
        break;
      case 3:
        this.view3();
        break;
    }
  }

  view2 = () => {
    this.view3Classes.forEach((className) => {
      this.classList.remove(className);
    });
  }

  view3 = () => {
    this.view3Classes.forEach((className) => {
      this.classList.add(className);
    });
  }

  loadMore = (url) => {
    axios.get(url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        const list = doc.querySelector(this.tagName.toLowerCase());
        const loader = doc.querySelector('collection-load');
        var loadUrl = null;
        if(loader != null) {
          loadUrl = loader.dataset.link;
        }
        this.innerHTML += list.innerHTML;
        this.dispatchEvent(new CustomEvent(Utils.E_COLLECTION_LOADED, { detail: {
          loadUrl: loadUrl,
        } }));
        
        window.history.replaceState(null, null, url);
        this.scroll2prod();
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      });
  }

  // --------------------------------------------------------------------------------------------
  // -- se presente il riferimento in localStorage lo usa per scrollare fino al prodotto indicato
  // --- (il codice che salva il riferimento è in ProductCard - product-card.js)
  scroll2prod = () => {
    const storedId = localStorage.getItem("clickedProductId");
    if (storedId) {
      localStorage.setItem("clickedProductId", "");
      const targetElement = document.getElementById(storedId);
      if (targetElement) {
		/* qui è stato impostato un ritardo di 1 sec per non interferire con lo scroll primario del sito. A regime i due scroll andrebbero unificati! */ 
        setTimeout(function () {
          targetElement.scrollIntoView({
            behavior: "smooth", 
            block: "center",
            inline: "nearest",
          });
        }, 1000);
      }
    }
  }
  
}
if (!window.customElements.get("collection-list")) {
  window.customElements.define("collection-list", CollectionList);
}

class CollectionView extends HTMLElement {
  list; view;
  static classes = {
    inactive: 'border-2',
  };
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.list = document.querySelector(this.getAttribute('href'));
    this.view = parseInt(this.dataset.view);

    if(this.list && this.list.tagName === 'COLLECTION-LIST') {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.active();
      });
    }
  }

  inactive = () => {
    this.classList.remove(CollectionView.classes.inactive);
    this.classList.remove('border-bottom');
  }

  active = () => {
    document.querySelectorAll('collection-view').forEach((view) => {
      view.inactive();
    });
    this.classList.add(CollectionView.classes.inactive);
    this.classList.add('border-bottom');
    this.list.view(this.view);
  }

}
if (!window.customElements.get("collection-view")) {
  window.customElements.define("collection-view", CollectionView);
}

class CollectionLoad extends HTMLElement {
  list; counter; total; link; loading; spinner;
  static selectors = {
    spinner: '[data-spinner]',
  }
  static classes = {
    loaded: 'd-none'
  }
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.list = document.querySelector(this.dataset.list);
    this.counter = document.querySelector(this.dataset.counter);
    this.spinner = this.querySelector(CollectionLoad.selectors.spinner);
    this.total = parseInt(this.dataset.total);
    this.link = this.dataset.link;
    this.loading = false;

    if(this.list.tagName === 'COLLECTION-LIST') {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadMore();
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMore();
          }
        });
      });

      observer.observe(this);
    }

    this.list.addEventListener(Utils.E_COLLECTION_LOADED, (e) => {
      this.updateLoader(e.detail.loadUrl);
    });
  }

  loadMore = () => {
    if(this.loading) {
      return;
    }
    this.loading = true;
    if(this.spinner)
      this.spinner.classList.remove(CollectionLoad.classes.loaded);
    this.list.loadMore(this.link);
  }

  updateLoader = (loadUrl) => {
    const num = this.list.querySelectorAll('product-card').length;
    this.link = loadUrl;
    if(this.counter != undefined){
      this.counter.innerHTML = num;
    }
    if(num >= this.total) {
      this.remove();
    }
    this.loading = false;
    if(this.spinner)
      this.spinner.classList.add(CollectionLoad.classes.loaded);
  }

}
if (!window.customElements.get("collection-load")) {
  window.customElements.define("collection-load", CollectionLoad);
}

class MainCollection extends HTMLElement {
  
  reload = (url) => {
    url = url || window.location.href;
    axios.get(url)
    .then((response) => {
      const doc = Utils.getDocument(response.data);
      const list = doc.querySelector(this.tagName.toLowerCase());
      this.innerHTML = list.innerHTML;
      window.history.replaceState(null, null, url);
    })
    .catch((error) => {
      Utils.errorHanlder(error);
    });
  }
}
if (!window.customElements.get("main-collection")) {
  window.customElements.define("main-collection", MainCollection);
}

class FiltersApply extends HTMLElement {
  text; num; form; button; inputs; selected; collection;
  static selectors = {
    button: 'button',
    form: 'form',
    inputs: 'input',
    selected: 'input:checked',
    collection: 'main-collection',
  }

  connectedCallback() {
    this.button = this.querySelector(FiltersApply.selectors.button);
    this.form = this.closest(FiltersApply.selectors.form);
    this.inputs = this.form.querySelectorAll(FiltersApply.selectors.inputs);
    this.selected = this.form.querySelectorAll(FiltersApply.selectors.selected);
    this.collection = document.querySelector(FiltersApply.selectors.collection);
    this.init();
  } 

  init = () => {
    this.text = this.button.innerHTML;
    this.num = this.selected.length;

    this.showNum();
    this.inputs.forEach((input) => {
      input.addEventListener('change', () => this.checkNum());
    });
  }

  checkNum = () => {
    this.selected = this.form.querySelectorAll(FiltersApply.selectors.selected);
    this.num = this.selected.length;
    this.showNum();
    this.reloadCollection();
  }

  reloadCollection = () => {
    if(this.collection){
      const url = `${this.form.action}?${new URLSearchParams(new FormData(this.form)).toString()}`;
      this.collection.reload(url);
    }
  }

  showNum = () => {
    if(this.num > 0)
      this.button.innerHTML = this.text + ' (' + this.num + ')';
    else
      this.button.innerHTML = this.text;
  }

}
if (!window.customElements.get("filters-apply")) {
  window.customElements.define("filters-apply", FiltersApply);
}

class FiltersBody extends HTMLElement {
  
  connectedCallback() {
    this.init();
  }
  /* Odio queste 4 righe */
  init = () => {
    this.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {});
    });
  }

  reload = (input) => {
    Shopify.analytics.publish('filters_applied', {
      filter: input.name,
      value: input.value,
    });
    const form = this.closest('form');
    if(form){
      const data = new FormData(form);
      const url = `${form.action}?${new URLSearchParams(data).toString()}`;
      axios.get(url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        const list = doc.querySelector(this.tagName.toLowerCase());
        this.innerHTML = list.innerHTML;
        this.init();
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      });
    }
  }
}
if (!window.customElements.get("filters-body")) {
  window.customElements.define("filters-body", FiltersBody);
}

class StickyHidden extends HTMLElement {
  
  connectedCallback() {
    setTimeout(this.init);
  }
  
  init = () => {    
    const sentinel = document.querySelector(this.dataset.sentinel);
    if(!sentinel) {
      console.warn('StickyHidden: sentinel not found');
      return;
    }
    const hiddenClass = this.dataset.class || 'opacity-0';
    const options = {};
    options.root = document.querySelector(this.dataset.root) || null;
    options.rootMargin = this.dataset.rootMargin || '0px';
    options.threshold = this.dataset.threshold ? parseFloat(this.dataset.threshold) : 0;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.classList.remove(hiddenClass);
        }
        else {
          this.classList.add(hiddenClass);
        }
      });
    }, options);

    observer.observe(sentinel);
  }
}
if (!window.customElements.get("sticky-hidden")) {
  window.customElements.define("sticky-hidden", StickyHidden);
}